// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nav-section_wrapper__2IeiQ"};